import styled from 'styled-components';
import { Colors } from '../../../../shared/colors/colors';

export const PhoneAlert = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: fit-content;
  max-height: 40px;
  padding: 8px 16px 8px 16px;
  gap: 8px;
  border-radius: 8px;
  background: ${Colors.telefoneAlertBackground};
  opacity: 0px;
  position: relative;
`;

export const RegistrationText = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: ${Colors.fontColorTable};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: nowrap;
  margin: 0;
`;

export const RegistrationNumber = styled.strong`
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: ${Colors.primary};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const DisabledFieldStyle = {
  backgroundColor: '#f9f9f9',
  opacity: 0.8,
  cursor: 'not-allowed'
};

export const CancelButton = styled.div`
  margin-left: 10px;
  display: inline-block;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  width: 90vw;
`;
